import React from 'react';
import { Dialog } from 'primereact/dialog';
import { ProgressBar } from 'primereact/progressbar';

interface CsvImportDialogProps {
  visible: boolean;
  progress: number;
  progressHeader: string;
  progressBarMax?: number; // Optional, not used in PrimeReact v10
}

export const CsvImportDialog: React.FC<CsvImportDialogProps> = ({
  visible,
  progress,
  progressHeader,
}) => {
  return (
    <Dialog 
      visible={visible} 
      header={progressHeader} 
      className="w-full md:w-30rem"
      contentClassName="p-4"
      modal
      closable={false}
      onHide={() => {}}
    >
      <ProgressBar 
        value={progress} 
        showValue={false}
        className="w-full"
      />
    </Dialog>
  );
};
